<template>
  <div v-if="docRequests.length > 0">
    <div>
      <ul>
        <li>
          <strong>Type Impression&nbsp;:</strong>
          {{ cogePrintCodesList.TypeImpCourrier[docRequests[0].request.TypeImpCourrier] }}
        </li>
        <li>
          <strong>Type Pli&nbsp;:</strong>
          {{ cogePrintCodesList.TypePli[docRequests[0].request.TypePli] }}
        </li>
        <li>
          <strong>Type de affranchissement&nbsp;:</strong>
          {{ cogePrintCodesList.TypeAff[docRequests[0].request.TypeAff] }}
        </li>
        <li v-if="getExpNumber">
          <strong>Suivi&nbsp;:&nbsp;</strong>
          <a :href="trackLetterDeliveryUrl + getExpNumber" target="_blank">{{ getExpNumber }}</a>
        </li>
      </ul>
    </div>
    <hr />
  </div>
</template>

<script>
import { trackLetterDeliveryUrl } from "@/constants/default.js";
export default {
  props: {
    docRequests: {
      type: Array,
      default: () => {
        return [];
      },
    },
    docResponses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      trackLetterDeliveryUrl,
      cogePrintCodesList: {
        TypeImpCourrier: {
          "001": "Impression laser noir recto sur A4 80gr",
          "002": "Impression laser noir recto-verso sur A4 80gr",
          "003": "Impression laser couleur recto sur A4 80gr",
          "004": "Impression laser couleur recto-verso sur A4 80gr",
          "005": "Impression jet d’encre recto sur A4 80gr",
          "006": "Impression jet d’encre recto-verso sur A4 80gr",
          "021":
            "Impression laser noir recto-verso sur A3 80 gr avec piqure à cheval(brochure uniquement)",
        },
        TypePli: {
          "001": "Insertion dans enveloppe 1/3 A4 avec fenêtre (capacité: max 5 A4)",
          "002": "Insertion dans enveloppe A4 avec fenêtre (capacité: 6-40 A4)",
          "003": "Insertion dans enveloppe A4  avec soufflet avec fenêtre (capacité:41 A4 et +)",
        },
        TypeAff: {
          "001": "Lettre recommandé égrenée avec AR métropole et OM 0-20 gr",
          "002": "Lettre recommandé égrenée avec AR métropole et OM 21-50 gr",
          "003": "Lettre recommandé égrenée avec AR métropole et OM 51-100 gr",
          "004": "Lettre recommandé égrenée avec AR métropole et OM 101-250 gr",
          "005": "Lettre recommandé égrenée avec AR métropole et OM 251-500 gr",
          "006": "Lettre recommandé égrenée avec AR métropole et OM 501-1000 gr",
          "007": "Lettre recommandé égrenée avec AR métropole et OM 1001-2000 gr",
          "008": "Lettre recommandé égrenée avec AR métropole et OM 2001-3000 gr",
          "021": "Lettre recommandé premium égrenée avec AR métropole et OM 0-20 gr",
          "022": "Lettre recommandé premium égrenée avec AR métropole et OM 21-50 gr",
          "023": "Lettre recommandé premium égrenée avec AR métropole et OM 51-100 gr",
          "024": "Lettre recommandé premium égrenée avec AR métropole et OM 101-250 gr",
          "025": "Lettre recommandé premium égrenée avec AR métropole et OM 251-500 gr",
          "026": "Lettre recommandé premium égrenée avec AR métropole et OM 501-1000 gr",
          "027": "Lettre recommandé premium égrenée avec AR métropole et OM 1001-2000 gr",
          "028": "Lettre recommandé premium égrenée avec AR métropole et OM 2001-3000 gr",
          "031": "Lettre Grand Compte LG2 métropole et OM 0-35 gr",
          "041": "Lettre Verte égrenée métropole et OM 0-20 gr",
          "042": "Lettre Verte égrenée métropole et OM 21-50 gr",
          "043": "Lettre Verte égrenée métropole et OM 51-100gr",
          "044": "Lettre Verte égrenée métropole et OM 101-250 gr",
          "045": "Lettre Verte égrenée métropole et OM 251-500 gr",
          "046": "Lettre Verte égrenée métropole et OM 501-1000 gr",
          "047": "Lettre Verte égrenée métropole et OM 1001-2000 gr",
          "048": "Lettre Verte égrenée métropole et OM 2001-3000 gr",
          "051": "Lettre prioritaire internationale 0-20 gr",
          "052": "Lettre prioritaire internationale 21-50 gr",
          "053": "Lettre prioritaire internationale 51-100 gr",
          "054": "Lettre prioritaire internationale 101-250 gr",
          "055": "Lettre prioritaire internationale 251-500 gr",
          "056": "Lettre prioritaire internationale 501-1000 gr",
          "057": "Lettre prioritaire internationale 1001-2000 gr",
          "058": "Lettre prioritaire internationale 2001-3000 gr",
          // eslint-disable-next-line prettier/prettier
          "100": "Colissimo France",
          // eslint-disable-next-line prettier/prettier
          "101": "Colissimo International",
        },
      },
    };
  },
  computed: {
    getExpNumber() {
      if (this.docResponses.length > 0) {
        const foundLastExpNumber = this.docResponses.find(
          element => element.ExpNumber && element.TypeProduction == this.type
        );
        if (foundLastExpNumber) {
          return foundLastExpNumber.ExpNumber;
        }
        return null;
      } else {
        return null;
      }
    },
  },
};
</script>
